import React from "react";
import repeIcon from "../images/repeIcon.png";

export default function IndexPill({ number, estado }) {
  return (
    <span className={`indexPill ${estado}`}>
      <img src={repeIcon} width="20" alt="Repe Icon" />
      <span>Repes</span>
    </span>
  );
}
